<template>
  <base-container :isLoading="isLoading">
    <div class="artisan-base">
      <!-- <van-nav-bar title="用户注册" ></van-nav-bar> -->
      <h2 class="artisan-center">找回密码</h2>
      <van-form @submit="submit" :show-error-message="false" style="margin-top: 16px;">
        <van-field
          class="field-round"
          required
          v-model="data.phone"
          placeholder="请输入手机号"
          :rules="[{ required: true, message: '请填写手机号',validator:validPhone }]"
        />
        <van-field
          class="field-round"
          v-model="data.phoneCode"
          required
          placeholder="请输入验证码"
          :rules="[{ required: true, message: '请填写验证码' }]"
        >
          <template #button>
            <van-button
              round
              :disabled="!isSendable"
              size="small"
              type="primary"
              @click="getPhoneCode"
            >
              发送验证码
              <span v-if="isSending">({{timeNo}})</span>
            </van-button>
          </template>
        </van-field>
        <van-field
          class="field-round"
          v-model="data.pwd"
          required
          type="password"
          placeholder="请输入密码,长度6到16位"
          :rules="[{ required: true, message: '请填写密码,长度6到16位',pattern:/^[\w_-]{6,16}$/ }]"
        />
        <div style="margin-top: 16px;">
          <van-button class="artisan-btn" round block type="info" native-type="submit">确认</van-button>
        </div>
      </van-form>
    </div>
  </base-container>
</template>
<script>
import { isMobile } from "@/util/validate";
import { forgetPwd, sendSMS } from "@/api/auth";
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      isLoading: false,
      isSending: false,
      timeNo: 60,
      timer: "",
      data: {
        pwd: "",
        phone: "",
        phoneCode: "",
      },
    };
  },
  computed: {
    isSendable() {
      if (this.isSending) return false;
      return this.validPhone(this.data.phone);
    },
  },
  methods: {
    validPhone(val) {
      return isMobile(val);
    },
    getPhoneCode() {
      this.isLoading = true;
      sendSMS(this.data.phone)
        .then(() => {
          this.isLoading = false;
          this.isSending = true;
          this.timeNo = 60;
          this.timer = setInterval(() => {
            if (this.timeNo == 0) {
              this.isSending = false;
              clearInterval(this.timer);
            } else {
              this.timeNo--;
            }
          }, 1000);
          Toast.success("发送验证码成功！");
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    submit() {
      Dialog.confirm({
        title: "提示",
        message: "确认找回密码？",
      }).then(() => {
        this.isLoading = true;
        forgetPwd(this.data)
          .then(() => {
            this.isLoading = false;
            Dialog.confirm({
              title: "密码找回成功！",
              message: "是否前往登录",
            }).then(() => {
              this.$router.push("/login");
            });
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
  },
};
</script>

<style>
</style>